export default __webpack_public_path__ + "static/media/jump-rope.1c8e54c7.jpg";